/**
 * Master list of help articles for LearnMore links.
 * Each key is a semantic ID
 * This list could also be fetched from the Intercom API eventually
 */
interface Article {
  /** Display text (for future use). */
  title: string;
  /** Intercom article number (for in-app display). */
  articleId: number;
  /** Full URL (fallback when Intercom is unavailable). */
  url: string;
  /** Content type — currently only "article". */
  type: "article";
}

export const articles = {
  // ── Charts ─────────────────────────────────────────
  cfd: {
    title: "Understanding the Cumulative Flow Diagram",
    articleId: 704406,
    url: "https://help.piplanning.io/en/articles/704406-understanding-the-cumulative-flow-diagram",
    type: "article",
  },
} satisfies Record<string, Article>;
